import { useEffect, useState } from "react";

/**
 * Returns `value` once it has stopped changing for `delayMs`. Starts out equal
 * to `value`, so a value already present on mount (e.g. from the URL) is used
 * straight away.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timeout);
  }, [value, delayMs]);

  return debounced;
}
